import * as React from 'react';
import { connect } from 'react-redux';
import {
  INotificationTemplate,
  INotificationType,
  INotificationTemplateHeader,
  INotificationTemplateSignature,
  INotificationTemplateType,
  ITemplateOptionSelection,
  ITemplateOption,
} from './business-objects/common';
import { Col, Row, Container, Form, Button } from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
  convertToRaw,
  EditorState,
  Modifier,
  RichUtils,
  ContentState,
  convertFromHTML,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import * as _ from 'lodash';
import NotificationTokens from '../NotificationTokens/NotificationTokens';
import MultiSelectList, {
  IMultiSelectListProps,
} from '../MultiSelect/MultiSelectList';
import { INameValue } from '../MultiSelect/common';
import { getTemplateOptions } from './redux-objects/actions';
import * as urls from '../shared/urls';

const $ = require('jquery'); //TODO: determine if this is still necessary?  I believe this is now being handled in webpack.

interface INotificationTemplateEditFormSuppliedProps {
  headerTemplates: INotificationTemplateHeader[];
  signatureTemplates: INotificationTemplateSignature[];
  notificationTypes: INotificationType[];
  //templateTypes: INotificationTemplateType[];
  templateOptions: ITemplateOption[];
  serviceURL: string;
}

interface INotificationTemplateEditFormActions {
  getTemplateOptions: (url: string) => Promise<void>;
}

interface INotificationTemplateEditFormOwnProps {
  templateToEdit: INotificationTemplate;
}

interface INotificationTemplateEditFormLocalState {
  [key: string]: EditorState;
  editorRef: any;
  currentTemplate: INotificationTemplate;
  headerStatus: eTemplateHeaderSignatureStatus;
  signatureStatus: eTemplateHeaderSignatureStatus;
  //templateOptionSelection: ITemplateOptionsSelection[];
}

enum eTemplateHeaderSignatureStatus {
  NoTemplate = 1,
  UseExisting,
  CreateNew,
}

enum eNotificationType {
  Email = 1,
  Postal,
  Both,
}

interface INotificationTemplateEditFormProps
  extends INotificationTemplateEditFormOwnProps,
    INotificationTemplateEditFormActions,
    INotificationTemplateEditFormSuppliedProps {}

export class NotificationTemplateEditForm extends React.Component<
  INotificationTemplateEditFormProps,
  INotificationTemplateEditFormLocalState
> {
  constructor(props) {
    super(props);
    this.state = {
      currentTemplate: null,
      editorRef: null,
      headerStatus: eTemplateHeaderSignatureStatus.NoTemplate,
      signatureStatus: eTemplateHeaderSignatureStatus.NoTemplate,
    };
  }

  componentDidMount() {
    const { templateOptions, serviceURL } = this.props;
    if (templateOptions.length == 0) {
      this.props.getTemplateOptions(
        `${serviceURL}${urls.LOAD_TEMPLATE_OPTIONS}`
      );
    }
  }

  /*TODO: This should be refactored as ComponentWillMount is being removed as of React 17,
  https://reactjs.org/docs/react-component.html#unsafe_componentwillmount.*/
  componentWillMount() {
    this.setState(
      {
        currentTemplate: {
          ..._.cloneDeep(this.props.templateToEdit),
          clientId: 2,
          notificationType: this.props.notificationTypes.find(
            (item) =>
              item.id ==
              (this.props.templateToEdit != null
                ? this.props.templateToEdit.notificationType.id
                : 1)
          ),
        },
      },
      () => {
        let curBodyState =
          this.state.currentTemplate.body != undefined
            ? this.getEditorStateFromHTML(this.state.currentTemplate.body)
            : EditorState.createEmpty();
        let curHeaderState =
          this.state.currentTemplate.notificationTemplateHeader != undefined &&
          this.state.currentTemplate.notificationTemplateHeader != null
            ? this.getEditorStateFromHTML(
                this.state.currentTemplate.notificationTemplateHeader.content
              )
            : EditorState.createEmpty();
        let curSignatureState =
          this.state.currentTemplate.notificationTemplateSignature !=
            undefined &&
          this.state.currentTemplate.notificationTemplateSignature != null
            ? this.getEditorStateFromHTML(
                this.state.currentTemplate.notificationTemplateSignature.content
              )
            : EditorState.createEmpty();
        this.setState({
          editorState: curBodyState,
          headerEditorState: curHeaderState,
          signatureEditorState: curSignatureState,
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTypeId: 3,
            templateTypeId: 1,
          },
          headerStatus: this.state.currentTemplate.notificationTemplateHeader
            ? eTemplateHeaderSignatureStatus.UseExisting
            : eTemplateHeaderSignatureStatus.NoTemplate,
          signatureStatus: this.state.currentTemplate
            .notificationTemplateSignature
            ? eTemplateHeaderSignatureStatus.UseExisting
            : eTemplateHeaderSignatureStatus.NoTemplate,
        });
      }
    );
  }

  getUpdatedTemplate = () => this.state.currentTemplate;

  handleTemplateChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case 'subject':
        this.setState({
          currentTemplate: { ...this.state.currentTemplate, subject: el.value },
        });
        break;
      case 'description':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            description: el.value,
          },
        });
        break;
      case 'template name':
        this.setState({
          currentTemplate: { ...this.state.currentTemplate, name: el.value },
        });
        break;
      case 'notification type':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationType: this.props.notificationTypes.find(
              (item) => item.id == parseInt(el.value)
            ),
          },
        });
        break;
      case 'send from':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            sendFrom: el.value,
          },
        });
        break;
      case 'send to':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            sendTo: el.value,
          },
        });
        break;
      case 'selected header':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateHeader: this.props.headerTemplates.find(
              (item) => item.id == parseInt(el.value)
            ),
          },
        });
        break;
      case 'header name':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateHeader: {
              ...this.state.currentTemplate.notificationTemplateHeader,
              name: el.value,
            },
          },
        });
        break;
      case 'header description':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateHeader: {
              ...this.state.currentTemplate.notificationTemplateHeader,
              description: el.value,
            },
          },
        });
        break;
      case 'selected signature':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateSignature: this.props.signatureTemplates.find(
              (item) => item.id == parseInt(el.value)
            ),
          },
        });
        break;
      case 'signature name':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateSignature: {
              ...this.state.currentTemplate.notificationTemplateSignature,
              name: el.value,
            },
          },
        });
        break;
      case 'signature description':
        this.setState({
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateSignature: {
              ...this.state.currentTemplate.notificationTemplateSignature,
              description: el.value,
            },
          },
        });
        break;
      case 'header no template':
        this.setState({
          headerStatus: eTemplateHeaderSignatureStatus.NoTemplate,
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateHeader: null,
          },
          headerEditorState: EditorState.createEmpty(),
        });
        break;
      case 'header use template':
        this.setState({
          headerStatus: eTemplateHeaderSignatureStatus.UseExisting,
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateHeader: this.props.headerTemplates.find(
              (item) => item.id == 1
            ),
          },
        });
        break;
      case 'header new template':
        this.setState({
          headerStatus: eTemplateHeaderSignatureStatus.CreateNew,
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateHeader: {
              ...({} as INotificationTemplateHeader),
              clientId: 2,
            },
          },
          headerEditorState: EditorState.createEmpty(),
        });
        break;
      case 'signature no template':
        this.setState({
          signatureStatus: eTemplateHeaderSignatureStatus.NoTemplate,
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateSignature: null,
          },
          signatureEditorState: EditorState.createEmpty(),
        });
        break;
      case 'signature use template':
        this.setState({
          signatureStatus: eTemplateHeaderSignatureStatus.UseExisting,
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateSignature: this.props.signatureTemplates.find(
              (item) => item.id == 1
            ),
          },
        });
        break;
      case 'signature new template':
        this.setState({
          signatureStatus: eTemplateHeaderSignatureStatus.CreateNew,
          currentTemplate: {
            ...this.state.currentTemplate,
            notificationTemplateSignature: {
              ...({} as INotificationTemplateSignature),
              clientId: 2,
            },
          },
          signatureEditorState: EditorState.createEmpty(),
        });
        break;
      default:
        break;
    }
  };

  getEditorStateFromHTML = (htmlString: string) => {
    if (this.props.templateToEdit && this.props.templateToEdit.id > 0) {
      const blocksFromHTML = convertFromHTML(htmlString);
      return EditorState.createWithContent(
        ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        )
      );
    }
    return null;
  };

  onBodyEditorStateChange = (editorBodyState: EditorState) => {
    let editorHTML = draftToHtml(
      convertToRaw(editorBodyState.getCurrentContent())
    );
    this.setState({
      editorState: editorBodyState,
      currentTemplate: { ...this.state.currentTemplate, body: editorHTML },
    });
  };

  onDragOver = (e) => {
    e.preventDefault();
  };

  onDrop = (e, field, type, controlId) => {
    const tagName = '#' + e.dataTransfer.getData('tagName') + '#';

    if (type === 'editor') {
      switch (field) {
        case 'body':
          let bodState = this.getEditorStateFromHTML(
            (this.state.currentTemplate.body || '') + tagName
          );
          this.onBodyEditorStateChange(bodState);
          break;
        case 'signature':
          let sigState = this.getEditorStateFromHTML(
            (this.state.currentTemplate.notificationTemplateSignature.content ||
              '') + tagName
          );
          this.onSignatureEditorStateChange(sigState);
          break;
        case 'header':
          let headState = this.getEditorStateFromHTML(
            (this.state.currentTemplate.notificationTemplateHeader.content ||
              '') + tagName
          );
          this.onHeaderEditorStateChange(headState);
          break;
      }
    } else if (type === 'textbox') {
      const index = $('#' + controlId).prop('selectionStart');
      const curValue = this.state.currentTemplate[field] || '';
      const newValue =
        curValue.slice(0, index) + tagName + curValue.slice(index + 1);
      this.setState({
        currentTemplate: {
          ...this.state.currentTemplate,
          [field]: newValue,
        },
      });
    }
  };

  onHeaderEditorStateChange = (editorHeaderState: EditorState) => {
    let editorHTML = draftToHtml(
      convertToRaw(editorHeaderState.getCurrentContent())
    );
    this.setState({
      headerEditorState: editorHeaderState,
      currentTemplate: {
        ...this.state.currentTemplate,
        notificationTemplateHeader: {
          ...this.state.currentTemplate.notificationTemplateHeader,
          content: editorHTML,
        },
      },
    });
  };

  onSignatureEditorStateChange = (editorSignatureState: EditorState) => {
    let editorHTML = draftToHtml(
      convertToRaw(editorSignatureState.getCurrentContent())
    );
    this.setState({
      signatureEditorState: editorSignatureState,
      currentTemplate: {
        ...this.state.currentTemplate,
        notificationTemplateSignature: {
          ...this.state.currentTemplate.notificationTemplateSignature,
          content: editorHTML,
        },
      },
    });
  };

  handleTab = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    let editorDescriptorElement = ((e.currentTarget as HTMLDivElement)
      .children[0] as HTMLDivElement).children[0] as HTMLDivElement;
    let currentState = EditorState.createEmpty();
    let targetStateKey = '';

    if (editorDescriptorElement.dataset.editor == 'eBody')
      targetStateKey = 'editorState';
    else if (editorDescriptorElement.dataset.editor == 'eHeader')
      targetStateKey = 'headerEditorState';
    else targetStateKey = 'signatureEditorState';
    currentState = this.state[targetStateKey];

    const selection = currentState.getSelection();
    const blockType = currentState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    if (
      blockType === 'unordered-list-item' ||
      blockType === 'ordered-list-item'
    ) {
      this.setState({ [targetStateKey]: RichUtils.onTab(e, currentState, 3) });
    } else {
      let newContentState = Modifier.insertText(
        currentState.getCurrentContent(),
        currentState.getSelection(),
        '    '
      );

      this.setState({
        [targetStateKey]: EditorState.push(
          currentState,
          newContentState,
          'insert-characters'
        ),
      });
    }
  };

  handleOptionSelect = (selectedList, selectedItem: INameValue) => {
    if(this.props.templateToEdit != null){
      const optionSelect: ITemplateOptionSelection = {
        id: 0,
        notificationTemplateId: this.props.templateToEdit.id,
        templateOptionId: parseInt(selectedItem.value),
        templateOption: {
          id: parseInt(selectedItem.value),
          name: selectedItem.name,
        },
      };
      this.setState(
          (prevState) => ({
            currentTemplate: {
              ...prevState.currentTemplate,
              templateOptionSelections: [
                ...prevState.currentTemplate.templateOptionSelections,
                optionSelect,
              ],
            },
          }),
          () => console.log(this.state.currentTemplate.templateOptionSelections)
      );
    } else {
      const optionSelect: ITemplateOptionSelection = {
        id: 0,
        notificationTemplateId: this.state.currentTemplate.notificationType.id,
        templateOptionId: parseInt(selectedItem.value),
        templateOption: {
          id: parseInt(selectedItem.value),
          name: selectedItem.name,
        },
      };
//template options never ends up as an object on currentNotification. Not sure why.
      this.setState(
          (prevState) => ({
            currentTemplate: {
              ...prevState.currentTemplate,
              templateOptionSelections: [
                optionSelect,
              ],
            },
          }),
      );
    }
    return true;
  };

  handleOptionRemove = (selectedList, selectedItem) => {
    const newOpts = this.state.currentTemplate.templateOptionSelections.filter(
      (option) => option.templateOption.id !== parseInt(selectedItem.value)
    );
    this.setState((prevState) => ({
      currentTemplate: {
        ...prevState.currentTemplate,
        templateOptionSelections: newOpts,
      },
    }));

    return true;
  };

  render() {
    const { templateOptions } = this.props;
    const msOptions = templateOptions.map((x) => ({
      name: x.name,
      value: x.id.toString(),
    }));
    let selectedOptions = []
    try{selectedOptions = this.state.currentTemplate.templateOptionSelections.map(
        (x) => ({
          name: x.templateOption.name,
          value: x.templateOption.id.toString(),
        })
    );
    } catch {}

    const templateSelectionProps: IMultiSelectListProps = {
      options: msOptions,
      onSelect: this.handleOptionSelect,
      onRemove: this.handleOptionRemove,
      title: 'Where is this available?',
      placeHolder: 'Select Options',
      selections: selectedOptions,
    };

    return (
      <Container>
        <Row className='flex-nowrap'>
          <Col xs={9}>
            <Form>
              <MultiSelectList {...templateSelectionProps} />
              <div
                className={
                  this.props.templateToEdit && this.props.templateToEdit.id < 0
                    ? 'display-none'
                    : ''
                }
              >
                <Form.Group controlId='templateName'>
                  <Form.Label>
                    <strong>Template Name</strong>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    data-field='template name'
                    placeholder='Enter letter template name...'
                    onChange={this.handleTemplateChange}
                    value={
                      this.state.currentTemplate != null
                        ? this.state.currentTemplate.name
                        : ''
                    }
                  />
                </Form.Group>

                <Form.Group controlId='templateDescription'>
                  <Form.Label>
                    <strong>Description</strong>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    data-field='description'
                    placeholder='Enter a description for the letter template...'
                    onChange={this.handleTemplateChange}
                    value={
                      this.state.currentTemplate != null
                        ? this.state.currentTemplate.description
                        : ''
                    }
                  />
                </Form.Group>

                <Form.Group controlId='templateNotificationType'>
                  <Form.Label>
                    <strong>Notification Type</strong>
                  </Form.Label>
                  <Form.Control
                    as='select'
                    onChange={this.handleTemplateChange}
                    data-field='notification type'
                    defaultValue={
                      this.state.currentTemplate != null &&
                      this.state.currentTemplate.notificationType != null
                        ? this.state.currentTemplate.notificationType.id
                        : 1
                    }
                  >
                    {this.props.notificationTypes.map((item, idx) => (
                      <option key={idx} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                <Form.Group controlId='templateSubject'>
                  <Form.Label>
                    <strong>Subject</strong>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    data-field='subject'
                    placeholder='Enter letter template subject...'
                    onChange={this.handleTemplateChange}
                    onDragOver={(e) => this.onDragOver(e)}
                    onDrop={(e) =>
                      this.onDrop(e, 'subject', 'textbox', 'templateSubject')
                    }
                    value={
                      this.state.currentTemplate != null
                        ? this.state.currentTemplate.subject
                        : ''
                    }
                  />
                </Form.Group>

                <Form.Group controlId='templateSendFrom'>
                  <Form.Label>
                    <strong>Send From</strong>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    data-field='send from'
                    placeholder='Enter who to send from...'
                    onChange={this.handleTemplateChange}
                    onDragOver={(e) => this.onDragOver(e)}
                    onDrop={(e) =>
                      this.onDrop(e, 'sendFrom', 'textbox', 'templateSendFrom')
                    }
                    value={
                      this.state.currentTemplate != null
                        ? this.state.currentTemplate.sendFrom || ''
                        : ''
                    }
                  />
                </Form.Group>

                <Form.Group controlId='templateSendTo'>
                  <Form.Label>
                    <strong>Send To</strong>
                  </Form.Label>
                  <Form.Control
                    as='input'
                    type='text'
                    data-field='send to'
                    placeholder='Enter who to send to...'
                    onChange={this.handleTemplateChange}
                    value={
                      this.state.currentTemplate != null
                        ? this.state.currentTemplate.sendTo || ''
                        : ''
                    }
                    onDragOver={(e) => this.onDragOver(e)}
                    onDrop={(e) =>
                      this.onDrop(e, 'sendTo', 'textbox', 'templateSendTo')
                    }
                  />
                </Form.Group>

                <Form.Group controlId='templateHeader'>
                  <Form.Label>
                    <strong>Header</strong>
                  </Form.Label>
                  <fieldset>
                    <Form.Check
                      type='radio'
                      label='No Header'
                      name='templateHeaderRadios'
                      onChange={this.handleTemplateChange}
                      data-field='header no template'
                      checked={
                        this.state.headerStatus ==
                        eTemplateHeaderSignatureStatus.NoTemplate
                      }
                    />
                    <Form.Check
                      type='radio'
                      label='Use Exisitng Header'
                      name='templateHeaderRadios'
                      data-field='header use template'
                      onChange={this.handleTemplateChange}
                      checked={
                        this.state.headerStatus ==
                        eTemplateHeaderSignatureStatus.UseExisting
                      }
                    />
                    <Form.Check
                      type='radio'
                      label='Create New Header'
                      name='templateHeaderRadios'
                      data-field='header new template'
                      onChange={this.handleTemplateChange}
                      checked={
                        this.state.headerStatus ==
                        eTemplateHeaderSignatureStatus.CreateNew
                      }
                    />
                  </fieldset>

                  {this.state.headerStatus ==
                    eTemplateHeaderSignatureStatus.UseExisting && (
                    <Form.Control
                      as='select'
                      onChange={this.handleTemplateChange}
                      data-field='selected header'
                      defaultValue={
                        this.state.currentTemplate != null &&
                        this.state.currentTemplate.notificationTemplateHeader !=
                          null
                          ? this.state.currentTemplate
                              .notificationTemplateHeader.id
                          : 1
                      }
                    >
                      {this.props.headerTemplates.map((item, idx) => (
                        <option key={idx} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Control>
                  )}

                  {this.state.headerStatus ==
                    eTemplateHeaderSignatureStatus.CreateNew && (
                    <React.Fragment>
                      <Form.Label>New Header Name</Form.Label>
                      <Form.Control
                        type='text'
                        data-field='header name'
                        placeholder='Enter a name for the header...'
                        onChange={this.handleTemplateChange}
                      />
                      <Form.Label>New Header Description</Form.Label>
                      <Form.Control
                        type='text'
                        data-field='header description'
                        placeholder='Enter a description for the header...'
                        onChange={this.handleTemplateChange}
                      />
                      <div
                        onDragOver={(e) => this.onDragOver(e)}
                        onDrop={(e) => this.onDrop(e, 'header', 'editor', '')}
                      >
                        <Form.Label>Header Content</Form.Label>
                        <Editor
                          wrapperClassName='wrapper-class'
                          editorClassName='editor-class'
                          onEditorStateChange={this.onHeaderEditorStateChange}
                          spellCheck={true}
                          onTab={this.handleTab}
                          editorKey='eHeader'
                          editorState={this.state.headerEditorState}
                          placeholder={'Enter header content...'}
                          toolbarHidden={false}
                          toolbar={{ options: ['image', 'remove'] }}
                          data-field='header editor'
                        />
                      </div>
                    </React.Fragment>
                  )}
                </Form.Group>

                <Form.Group
                  controlId='templateBody'
                  onDragOver={(e) => this.onDragOver(e)}
                  onDrop={(e) =>
                    this.onDrop(e, 'body', 'editor', 'templateBody')
                  }
                >
                  <Form.Label>
                    <strong>Body Content</strong>
                  </Form.Label>
                  <Editor
                    wrapperClassName='wrapper-class'
                    editorClassName='editor-class'
                    onEditorStateChange={this.onBodyEditorStateChange}
                    spellCheck={true}
                    onTab={this.handleTab}
                    editorKey='eBody'
                    editorState={this.state.editorState}
                    placeholder='Enter body content ...'
                    toolbarHidden={false}
                    toolbar={{
                      options: [
                        'inline',
                        'blockType',
                        'fontSize',
                        'fontFamily',
                        'list',
                        'textAlign',
                        'link',
                        'image',
                        'remove',
                        'history',
                      ],
                    }}
                    data-field='body editor'
                    handleDrop={() => 'handled'}
                    //editorRef={this.setEditorReference}
                    // onDragOver={e => this.onDragOver(e)}
                    // onDrop={e => this.onDrop(e, 'body')}
                  />
                </Form.Group>

                <Form.Group controlId='templateSignature'>
                  <Form.Label>
                    <strong>Signature</strong>
                  </Form.Label>
                  <fieldset>
                    <Form.Check
                      type='radio'
                      label='No Signature'
                      name='templateSignatureRadios'
                      data-field='signature no template'
                      onChange={this.handleTemplateChange}
                      checked={
                        this.state.signatureStatus ==
                        eTemplateHeaderSignatureStatus.NoTemplate
                      }
                    />
                    <Form.Check
                      type='radio'
                      label='Use Exisitng Signature'
                      name='templateSignatureRadios'
                      data-field='signature use template'
                      onChange={this.handleTemplateChange}
                      checked={
                        this.state.signatureStatus ==
                        eTemplateHeaderSignatureStatus.UseExisting
                      }
                    />
                    <Form.Check
                      type='radio'
                      label='Create New Signature'
                      name='templateSignatureRadios'
                      data-field='signature new template'
                      onChange={this.handleTemplateChange}
                      checked={
                        this.state.signatureStatus ==
                        eTemplateHeaderSignatureStatus.CreateNew
                      }
                    />
                  </fieldset>

                  {this.state.signatureStatus ==
                    eTemplateHeaderSignatureStatus.UseExisting && (
                    <Form.Control
                      as='select'
                      onChange={this.handleTemplateChange}
                      data-field='selected signature'
                      defaultValue={
                        this.state.currentTemplate != null &&
                        this.state.currentTemplate
                          .notificationTemplateSignature != null
                          ? this.state.currentTemplate
                              .notificationTemplateSignature.id
                          : 1
                      }
                    >
                      {this.props.signatureTemplates.map((item, idx) => (
                        <option key={idx} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Control>
                  )}

                  {this.state.signatureStatus ==
                    eTemplateHeaderSignatureStatus.CreateNew && (
                    <React.Fragment>
                      <div
                        onDragOver={(e) => this.onDragOver(e)}
                        onDrop={(e) =>
                          this.onDrop(e, 'signature', 'editor', '')
                        }
                      >
                        <Form.Label>Signature Name</Form.Label>
                        <Form.Control
                          type='text'
                          data-field='signature name'
                          placeholder='Enter a name for the signature...'
                          onChange={this.handleTemplateChange}
                        />
                        <Form.Label>Signature Description</Form.Label>
                        <Form.Control
                          type='text'
                          data-field='signature description'
                          placeholder='Enter a description for the signature...'
                          onChange={this.handleTemplateChange}
                        />
                        <Form.Label>Signature Content</Form.Label>
                        <Editor
                          wrapperClassName='wrapper-class'
                          editorClassName='editor-class'
                          onEditorStateChange={
                            this.onSignatureEditorStateChange
                          }
                          spellCheck={true}
                          onTab={this.handleTab}
                          editorKey='eSignature'
                          editorState={this.state.signatureEditorState}
                          placeholder={'Enter signature content...'}
                          toolbarHidden={false}
                          toolbar={{
                            options: [
                              'inline',
                              'blockType',
                              'fontSize',
                              'fontFamily',
                              'list',
                              'textAlign',
                              'link',
                              'image',
                              'remove',
                              'history',
                            ],
                          }}
                          data-field='signature editor'
                        />
                      </div>
                    </React.Fragment>
                  )}
                </Form.Group>
              </div>
            </Form>
          </Col>
          {this.props.templateToEdit && this.props.templateToEdit.id > 0 && (
            <Col>
              <NotificationTokens />
            </Col>
          )}
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    headerTemplates: reduxState.NotificationTemplates.headerTemplates,
    signatureTemplates: reduxState.NotificationTemplates.signatureTemplates,
    notificationTypes: reduxState.NotificationTemplates.notificationTypes,
    //templateTypes: reduxState.DatatableExample.templateTypes
    templateOptions: reduxState.NotificationTemplates.templateOptions,
    serviceURL: reduxState.Application.backendURL,
  };
};

const mapDispatchToProps = {
  getTemplateOptions,
};

export default connect<any, any>(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(NotificationTemplateEditForm);
